/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CostcoStoreArea
 */
export interface CostcoStoreArea {
    /**
     * 
     * @type {string}
     * @memberof CostcoStoreArea
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CostcoStoreArea
     */
    name: string;
}

/**
 * Check if a given object implements the CostcoStoreArea interface.
 */
export function instanceOfCostcoStoreArea(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function CostcoStoreAreaFromJSON(json: any): CostcoStoreArea {
    return CostcoStoreAreaFromJSONTyped(json, false);
}

export function CostcoStoreAreaFromJSONTyped(json: any, ignoreDiscriminator: boolean): CostcoStoreArea {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function CostcoStoreAreaToJSON(value?: CostcoStoreArea | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

